import { PROJECT_BLOG_CASES, PROJECT_GENERATE_FROM, PROJECT_WTM_CASES } from 'src/data/project';
import { GENERATION_TOOL } from 'src/data/generationTool';
import ProductDescriptionParagraph from 'src/assets/icons/generationTools/ProductDescriptionParagraph';
import { IconFacebook } from 'src/assets/icons/generationTools/scoreIcons/IconFacebook';
import { IconTwitter } from 'src/assets/icons/generationTools/scoreIcons/IconTwitter';
import { IconGoogle } from 'src/assets/icons/generationTools/scoreIcons/IconGoogle';
import { IconLinkedin } from 'src/assets/icons/generationTools/scoreIcons/IconLinkedin';
import { IconPinterest } from 'src/assets/icons/generationTools/scoreIcons/IconPinterest';
import { IconInstagram } from 'src/assets/icons/generationTools/scoreIcons/IconInstagram';
import { IconYoutube } from 'src/assets/icons/generationTools/scoreIcons/IconYoutube';
import { IconLandingPage } from 'src/assets/icons/generationTools/scoreIcons/IconLandingPage';
import { IconLandingPageSeo } from 'src/assets/icons/generationTools/scoreIcons/IconLandingPageSeo';
import { IconAmazon } from 'src/assets/icons/generationTools/scoreIcons/IconAmazon';
import { IconWalmart } from 'src/assets/icons/generationTools/scoreIcons/IconWalmart';
import { IconEmailSubjectLine } from 'src/assets/icons/generationTools/scoreIcons/IconEmailSubjectLine';
import { IconPromotionalEmail } from 'src/assets/icons/generationTools/scoreIcons/IconPromotionalEmail';
import { IconColdEmail } from 'src/assets/icons/generationTools/scoreIcons/IconColdEmail';
import { IconSms } from 'src/assets/icons/generationTools/scoreIcons/IconSms';
import { IconOutbrain } from 'src/assets/icons/generationTools/scoreIcons/IconOutbrain';
import { IconTaboola } from 'src/assets/icons/generationTools/scoreIcons/IconTaboola';
import { IconTeads } from 'src/assets/icons/generationTools/IconTeads';
import { IconFreestyleTool } from 'src/assets/icons/generationTools/IconFreestyleTool';
import { IconPersonalBio } from 'src/assets/icons/generationTools/IconPersonalBio';
import { IconWTM } from 'src/assets/icons/IconWTM';
import { IconBlogPapers } from 'src/assets/icons/generationTools/scoreIcons/IconBlogPapers';
import { IconHomePage } from 'src/assets/icons/generationTools/scoreIcons/IconHomePage';

const ICONS = {
  // "data driven"
  [GENERATION_TOOL.facebookPrimaryTextProduct]: IconFacebook,
  [GENERATION_TOOL.facebookPrimaryTextProductRewrite]: IconFacebook,
  [GENERATION_TOOL.facebookHeadlineProduct]: IconFacebook,
  [GENERATION_TOOL.googleRSA]: IconGoogle,
  [GENERATION_TOOL.googleDescriptionProduct]: IconGoogle,
  [GENERATION_TOOL.googleHeadlineProductRewrite]: IconGoogle,
  [GENERATION_TOOL.googleDescriptionProductRewrite]: IconGoogle,
  [GENERATION_TOOL.googleHeadlineProduct]: IconGoogle,
  [GENERATION_TOOL.outbrainHeadlineProduct]: IconOutbrain,
  [GENERATION_TOOL.outbrainHeadlineProductRewrite]: IconOutbrain,
  [GENERATION_TOOL.taboolaHeadlineProduct]: IconTaboola,
  [GENERATION_TOOL.taboolaHeadlineProductRewrite]: IconTaboola,
  [GENERATION_TOOL.twitterCopyProduct]: IconTwitter,
  [GENERATION_TOOL.twitterCopyProductRewrite]: IconTwitter,
  [GENERATION_TOOL.twitterTitleProduct]: IconTwitter,
  [GENERATION_TOOL.pinterestDescriptionProduct]: IconPinterest,
  [GENERATION_TOOL.pinterestDescriptionProductRewrite]: IconPinterest,
  [GENERATION_TOOL.pinterestTitleProduct]: IconPinterest,
  [GENERATION_TOOL.landingHeadline]: IconLandingPage,
  [GENERATION_TOOL.landingHeadlineRewrite]: IconLandingPage,
  [GENERATION_TOOL.landingSubheader]: IconLandingPage,
  [GENERATION_TOOL.landingSubheaderRewrite]: IconLandingPage,
  [GENERATION_TOOL.landingCTA]: IconLandingPage,
  [GENERATION_TOOL.landingBenefits]: IconLandingPage,
  [GENERATION_TOOL.landingFeatures]: IconLandingPage,
  [GENERATION_TOOL.landingSEOMetadata]: IconLandingPageSeo,
  [GENERATION_TOOL.landingSEOMetadataRewrite]: IconLandingPageSeo,
  [GENERATION_TOOL.amazonProductListing]: IconAmazon,
  [GENERATION_TOOL.walmartProductListing]: IconWalmart,
  [GENERATION_TOOL.instagramCaption]: IconInstagram,
  [GENERATION_TOOL.facebookPost]: IconFacebook,
  [GENERATION_TOOL.tweet]: IconTwitter,
  [GENERATION_TOOL.linkedinPost]: IconLinkedin,
  [GENERATION_TOOL.linkedinPostRewrite]: IconLinkedin,
  [GENERATION_TOOL.pinterestPostDescription]: IconPinterest,
  [GENERATION_TOOL.pinterestPostTitle]: IconPinterest,
  [GENERATION_TOOL.youtubeTitle]: IconYoutube,
  [GENERATION_TOOL.youtubeDescription]: IconYoutube,
  [GENERATION_TOOL.emailSubjectLine]: IconEmailSubjectLine,
  [GENERATION_TOOL.emailSubjectLineRewrite]: IconEmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalSubjectLine]: IconPromotionalEmail,
  [GENERATION_TOOL.emailPromotionalBody]: IconPromotionalEmail,
  [GENERATION_TOOL.emailColdOutreachSubjectLine]: IconColdEmail,
  [GENERATION_TOOL.emailColdOutreachBody]: IconColdEmail,
  [GENERATION_TOOL.emailColdOutreachBodyRewrite]: IconColdEmail,
  [GENERATION_TOOL.smsPromotional]: IconSms,
  [GENERATION_TOOL.smsPromotionalRewrite]: IconSms,
  [GENERATION_TOOL.facebookPrimaryTextContent]: IconFacebook,
  [GENERATION_TOOL.facebookHeadlineContent]: IconFacebook,
  [GENERATION_TOOL.outbrainHeadlineContent]: IconOutbrain,
  [GENERATION_TOOL.taboolaHeadlineContent]: IconTaboola,
  [GENERATION_TOOL.twitterCopyContent]: IconTwitter,
  [GENERATION_TOOL.pinterestDescriptionContent]: IconPinterest,
  [GENERATION_TOOL.pinterestTitleContent]: IconPinterest,
  [GENERATION_TOOL.teadsSingleImageHeadline]: IconTeads,
  [GENERATION_TOOL.teadsSingleImageDescription]: IconTeads,
  [GENERATION_TOOL.teadsSingleVideoHeadline]: IconTeads,
  [GENERATION_TOOL.teadsSingleVideoDescription]: IconTeads,
  [GENERATION_TOOL.teadsCarouselHeadline]: IconTeads,
  [GENERATION_TOOL.teadsSocialLayout1Headline]: IconTeads,
  [GENERATION_TOOL.teadsSocialLayout1PrimaryText]: IconTeads,
  [GENERATION_TOOL.teadsSocialLayout1Description]: IconTeads,
  [GENERATION_TOOL.teadsSocialLayout2PrimaryText]: IconTeads,
  [GENERATION_TOOL.generalProductListing]: ProductDescriptionParagraph,
  [GENERATION_TOOL.linkedinHeadlineSingleImageRewrite]: IconLinkedin,
  [GENERATION_TOOL.linkedinIntroSingleImageRewrite]: IconLinkedin,
  [GENERATION_TOOL.instagramCaptionRewrite]: IconInstagram,
  [GENERATION_TOOL.facebookPostRewrite]: IconFacebook,
  [GENERATION_TOOL.pinterestPinTitleRewrite]: IconPinterest,
  [GENERATION_TOOL.pinterestPinDescriptionRewrite]: IconPinterest,
  [GENERATION_TOOL.tweetRewrite]: IconTwitter,
  [GENERATION_TOOL.linkedinHeadlineSingleImage]: IconLinkedin,
  [GENERATION_TOOL.linkedinIntroSingleImage]: IconLinkedin,
  [GENERATION_TOOL.articleBlogHeadline]: IconBlogPapers,

  // Freestyle
  [GENERATION_TOOL.freestyle]: IconFreestyleTool,
  [GENERATION_TOOL.createYourOwn]: IconFreestyleTool,

  //project blog
  [PROJECT_GENERATE_FROM.url]: IconBlogPapers,
  [PROJECT_GENERATE_FROM.description]: IconPersonalBio,
  [PROJECT_BLOG_CASES.description]: IconPersonalBio,

  // project wtm
  [PROJECT_WTM_CASES.default]: IconWTM,

  //WTM scores
  [GENERATION_TOOL.lpcoLandingHeadline]: IconHomePage,
  [GENERATION_TOOL.lpcoLandingCTA]: IconHomePage,
  [GENERATION_TOOL.lpcoLandingProductDescription]: IconHomePage,
  [GENERATION_TOOL.lpcoLandingCopy]: IconHomePage,
  [GENERATION_TOOL.lpcoLandingProductName]: IconHomePage,
};

export const getGenerationToolIcon = (as) => ICONS[as] || IconBlogPapers;
